import request from '@/utils/request';

//查询totalSales 接口
// export function getTotalSales(param) {
//   return request('/bhc-report/querySalesReport', {
//     method: 'POST',
//     data: param,
//   });
// }

//totalSales右侧图表接口
export function getTotalSalesReport(param) {
  return request('/bhc-report/querySalesTrendReport', {
    method: 'POST',
    data: param,
  });
}

// 查询totalCustomer接口
export function getTotalCustomer(param) {
  return request('/bhc-report/queryCustomerReport', {
    method: 'POST',
    data: param,
  });
}

// kpi 查询客单价趋势接口
export function getKpiBasket(param) {
  return request('/bhc-report/queryKpiBasket', {
    method: 'POST',
    data: param,
  });
}
// 查询会员贡献趋势接口
export function getKpiContribution(param) {
  return request('/bhc-report/queryKpiContribution', {
    method: 'POST',
    data: param,
  });
}
// 查询会员趋势接口
export function getKpiCustomer(param) {
  return request('/bhc-report/queryKpiCustomer', {
    method: 'POST',
    data: param,
  });
}
// 查询新招会员趋势接口
export function getKpiRecruitment(param) {
  return request('/bhc-report/queryKpiRecruitment', {
    method: 'POST',
    data: param,
  });
}
// 查询复购趋势接口
export function getKpiRepeat(param) {
  return request('/bhc-report/queryKpiRepeat', {
    method: 'POST',
    data: param,
  });
}
// 查询留存趋势接口
export function getKpiRetention(param) {
  return request('/bhc-report/queryKpiRetention', {
    method: 'POST',
    data: param,
  });
}
// 查询人均购买趋势接口
export function getKpiSpending(param) {
  return request('/bhc-report/queryKpiSpending', {
    method: 'POST',
    data: param,
  });
}
// 查询客单件趋势接口
export function getKpiUpt(param) {
  return request('/bhc-report/queryKpiUpt', {
    method: 'POST',
    data: param,
  });
}
// 查询主推产品接口
export function getHotProduct(param) {
  return request('/bhc-report/queryHotProduct', {
    method: 'POST',
    data: param,
  });
}
// 查询时间接口
export function getTime(param) {
  return request('/bhc-report/queryLabel', {
    method: 'GET',
    params: param,
  });
}
// 查询渠道接口
export function getChannel() {
  return request('/bhc-report/queryChannel', {
    method: 'POST',
    // data: param,
  });
}
// 查询子渠道接口
export function getSubChannel(param) {
  return request('/bhc-report/querySubChannel', {
    method: 'POST',
    data: param,
  });
}

// 查询销售额接口
export function getTotalSalesV2(param) {
  return request('/bhc-report/queryTotalSalesReport', {
    method: 'POST',
    data: param,
  });
}

// 查询销售额趋势
export function getTotalSalesReportV2(param) {
  return request('/bhc-report/queryBhcSalesTrendReport', {
    method: 'POST',
    data: param,
  });
}

// 查询会员数接口
export function getMemberReport(param) {
  return request('/bhc-report/member-report', {
    method: 'POST',
    data: param,
  });
}

// 查询趋势接口
export function getKpiTrendReport(param) {
  return request('/bhc-report/kpiTrendReport', {
    method: 'POST',
    data: param,
  });
}
